export default {
    totalworker: '総作業員人数',
    gyoshu: 'FC担当者'
};
